import { gql, useQuery } from '@apollo/client'
import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { useParams } from 'react-router'

import { DATAROOM_FRAGMENT } from '../constants'
import Create from './Create'
import StagesTable from './StagesTable'
import { STAGE_FRAGMENT } from './constants'
import DataroomContext from './context'

const DATAROOM = gql`
  ${DATAROOM_FRAGMENT}
  ${STAGE_FRAGMENT}
  query DATAROOM($id: ID!) {
    dataroom(id: $id) {
      ...DataroomFragment
      stages {
        ...StageFragment
      }
    }
  }
`

function NoStagesFound() {
  const theme = useTheme()

  return (
    <Stack
      sx={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
    >
      <Typography sx={{ color: theme.palette.text.secondary }}>
        <b>No stages found.</b> Click the + button to add a stage.
      </Typography>
    </Stack>
  )
}

function Stages() {
  const { id } = useParams()
  const theme = useTheme()

  const { loading, error, data } = useQuery(DATAROOM, { variables: { id } })

  if (loading)
    return (
      <Stack
        sx={{ alignItems: 'center', justifyContent: 'center', height: '100%' }}
      >
        <CircularProgress />
      </Stack>
    )
  if (error) return <p>error...</p>

  const { dataroom } = data

  return (
    <Stack sx={{ height: '100%', p: 2 }}>
      <Typography
        sx={{
          ...theme.typography.h4,
          color: theme.palette.text.primary,
          fontWeight: 'light',
        }}
      >
        {dataroom.name}
      </Typography>
      <DataroomContext.Provider value={{ dataroom }}>
        <Box sx={{ p: 1, position: 'relative', height: '100%' }}>
          <Create />
          {dataroom.stages?.length ? <StagesTable /> : <NoStagesFound />}
        </Box>
      </DataroomContext.Provider>
    </Stack>
  )
}

export default Stages
